const MENU_CACHE_LIMIT = 8;

export { MENU_CACHE_LIMIT };
